'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

require("whatwg-fetch");

var _lodash = _interopRequireDefault(require("lodash"));

var _conf = _interopRequireDefault(require("../../conf"));

var _baseForm = _interopRequireDefault(require("./../base-form"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _formInputs = require("../form-inputs");

var _translate = _interopRequireDefault(require("../translate"));

var _datamasterForms = require("datamaster-forms");

var _files = require("./lib/files");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

_es6Promise.default.polyfill();

var Farm = /*#__PURE__*/function (_BaseForm) {
  _inherits(Farm, _BaseForm);

  function Farm(props) {
    var _this;

    _classCallCheck(this, Farm);

    _this = _possibleConstructorReturn(this, (Farm.__proto__ || Object.getPrototypeOf(Farm)).call(this, props));
    _this.state = _lodash.default.extend(_this.state, {
      salutation: [],
      canton: [],
      languages: [],
      animals: [],
      cultures: [],
      productiontype: [],
      zones: [],
      productionlabels: [],
      programs: [],
      operatingmode: [],
      acquisitiontype: [],
      uploadModalOpen: {
        images: false,
        documents: false
      },
      isSaving: false
    });
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleInputChangeMultiSelect = _this.handleInputChangeMultiSelect.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.onMarkerMoved = _this.onMarkerMoved.bind(_assertThisInitialized(_this));
    _this.loadFarmDataOnly = _this.loadFarmDataOnly.bind(_assertThisInitialized(_this));
    _this.onUpdateMainImage = _this.onUpdateMainImage.bind(_assertThisInitialized(_this));
    _this.applyImage = _this.applyImage.bind(_assertThisInitialized(_this));
    _this.onUpdateLogo = _this.onUpdateLogo.bind(_assertThisInitialized(_this));
    _this.onDeleteFile = _this.onDeleteFile.bind(_assertThisInitialized(_this));
    _this.onUploadFile = _this.onUploadFile.bind(_assertThisInitialized(_this));
    _this.onUpdateSorting = _this.onUpdateSorting.bind(_assertThisInitialized(_this));
    _this.saveSuggestionData = _this.saveSuggestionData.bind(_assertThisInitialized(_this));
    _this.onGeocode = _this.onGeocode.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   *
   */


  _createClass(Farm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      fetch(_conf.default.api.cantonApiUrlTemplate(this.props.i18n.language), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (cantons) {
        _this2.setState(function (prev) {
          prev.canton = cantons;
          return prev;
        });

        return fetch(_conf.default.api.animalApiUrlTemplate(_this2.props.i18n.language), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus);
      }).then(function (animals) {
        _this2.setState(function (prev) {
          prev.animals = animals;
          return prev;
        });

        return fetch(_conf.default.api.zoneApiUrlTemplate(_this2.props.i18n.language), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus);
      }).then(function (zones) {
        _this2.setState(function (prev) {
          prev.zones = zones;
          return prev;
        });

        return fetch(_conf.default.api.salutationApiUrlTemplate(_this2.props.i18n.language), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus);
      }).then(function (salutations) {
        _this2.setState(function (prev) {
          prev.salutation = salutations;
          return prev;
        });

        return fetch(_conf.default.api.correspondenceLanguageApiUrlTemplate(_this2.props.i18n.language), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus);
      }).then(function (languages) {
        _this2.setState(function (prev) {
          prev.languages = languages;
          return prev;
        });

        return fetch(_conf.default.api.culturesApiUrlTemplate(_this2.props.i18n.language), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus);
      }).then(function (cultures) {
        _this2.setState(function (prev) {
          prev.cultures = cultures;
          return prev;
        });

        return fetch(_conf.default.api.productiontypesApiUrlTemplate(_this2.props.i18n.language), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus);
      }).then(function (productiontypes) {
        _this2.setState(function (prev) {
          prev.productiontype = productiontypes;
          return prev;
        });

        return fetch(_conf.default.api.productionlabelsApiUrlTemplate(_this2.props.i18n.language), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus);
      }).then(function (productionlabels) {
        _this2.setState(function (prev) {
          prev.productionlabels = productionlabels;
          return prev;
        });

        return fetch(_conf.default.api.programsApiUrlTemplate(_this2.props.i18n.language), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus);
      }).then(function (programs) {
        _this2.setState(function (prev) {
          prev.programs = programs;
          return prev;
        });

        return fetch(_conf.default.api.operatingmodesApiUrlTemplate(_this2.props.i18n.language), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus);
      }).then(function (operatingmodes) {
        _this2.setState(function (prev) {
          prev.operatingmode = operatingmodes;
          return prev;
        });

        return fetch(_conf.default.api.acquisitiontypesApiUrlTemplate(_this2.props.i18n.language), {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus);
      }).then(function (acquisitiontypes) {
        _this2.setState(function (prev) {
          prev.acquisitiontype = acquisitiontypes;
          return prev;
        });
      }).catch(function (err) {
        _this2.setState(function (prev) {
          prev.form.error = err.message;
          return prev;
        });
      });
    }
    /**
     *
     * @returns {*}
     */

  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("div", {
        id: this.props.anchorId || '',
        className: "comp-farm comp-base-form"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "form-title"
      }, t('farm')), this.topMessage(), /*#__PURE__*/_react.default.createElement(_datamasterForms.FarmForm, {
        t: t,
        farm: this.props.farm,
        showFarmNoEmailCheckbox: true,
        invalidFields: this.state.form.invalidFields,
        programCases: [1, 2, 3, 4],
        texts: {
          sectionDescription: {
            imageUpload: {
              chooseFile: t('datamaster-forms:::image-please-choose'),
              uploadFiles: t('datamaster-forms:::file-upload-upload-image'),
              fileSizeExceeded: t('datamaster-forms:::file-upload-image-error-size-exceeded'),
              unknownError: t('datamaster-forms:::file-upload-unknown-error'),
              removeFile: t('datamaster-forms:::file-upload-remove-image'),
              addMore: t('datamaster-forms:::file-upload-remove-image-add-more'),
              notAnImage: t('datamaster-forms:::file-upload-image-error-not-an-image'),
              notallowedtouploadthefile: t('datamaster-forms:::file-upload-file-not-allowed'),
              titleImage: t('datamaster-forms:::file-upload-image-title-image'),
              logo: t('datamaster-forms:::file-upload-image-logo')
            },
            fileUpload: {
              chooseFile: t('datamaster-forms:::image-please-choose'),
              uploadFiles: t('datamaster-forms:::file-upload-upload-image'),
              fileSizeExceeded: t('datamaster-forms:::file-upload-image-error-size-exceeded'),
              unknownError: t('datamaster-forms:::file-upload-unknown-error'),
              removeFile: t('datamaster-forms:::file-upload-remove-image'),
              addMore: t('datamaster-forms:::file-upload-remove-image-add-more'),
              notAnImage: t('datamaster-forms:::file-upload-image-error-not-an-image'),
              notallowedtouploadthefile: t('datamaster-forms:::file-upload-file-not-allowed'),
              titleImage: t('datamaster-forms:::file-upload-image-title-image'),
              logo: t('datamaster-forms:::file-upload-image-logo')
            }
          }
        },
        shared: {
          canton: this.state.canton,
          operatingmode: this.state.operatingmode,
          salutation: this.state.salutation,
          otherlanguages: this.state.languages,
          productiontype: this.state.productiontype,
          animals: this.state.animals,
          cultures: this.state.cultures,
          acquisitiontype: this.state.acquisitiontype,
          zones: this.state.zones,
          productionlabels: this.state.productionlabels,
          programs: this.state.programs
        },
        fileUploadUrl: "/api/".concat(this.props.i18n.language, "/farms/").concat(this.props.id, "/documents/new"),
        imageUploadUrl: "/api/".concat(this.props.i18n.language, "/farms/").concat(this.props.id, "/images/new"),
        onFileUpload: this.onUploadFile,
        onFileRemove: this.onDeleteFile,
        onUpdateMainImage: this.onUpdateMainImage,
        onUpdateLogo: this.onUpdateLogo,
        onUpdateSorting: this.onUpdateSorting,
        handleInputChange: this.handleInputChange,
        handleInputMultiSelectChange: this.handleInputChangeMultiSelect,
        saveContactFields: this.handleSubmit,
        saveDescriptionFields: this.handleSubmit,
        saveOperationalFields: this.handleSubmit,
        saveOthersFields: this.handleSubmit,
        saveProgramsFields: this.handleSubmit,
        onGeocode: this.onGeocode,
        onMarkerMoved: this.onMarkerMoved,
        onZipSuggestionSelected: this.saveSuggestionData,
        progress: {
          contact: false,
          description: false,
          operation: false,
          other: false,
          program: false
        },
        isSaving: {
          contact: this.state.form.isSaving,
          description: this.state.form.isSaving,
          operational: this.state.form.isSaving,
          programs: this.state.form.isSaving,
          other: this.state.form.isSaving
        },
        success: {
          contact: this.state.form.success,
          description: this.state.form.success,
          operational: this.state.form.success,
          others: this.state.form.success,
          programs: this.state.form.success
        },
        error: {
          contact: this.state.form.error,
          description: this.state.form.error,
          operation: this.state.form.error,
          other: this.state.form.error,
          program: this.state.form.error
        },
        InputTelephone: _formInputs.TelephoneInput,
        InputSelect: _formInputs.AdapterSelect,
        InputField: _formInputs.TextInput,
        InputTextarea: _formInputs.TextareaInput,
        MultiSelectText: _formInputs.AdapterMultiSelect,
        InputCheckbox: _formInputs.CheckboxInput,
        cantonApiEndpoint: _conf.default.api.cantonApiUrlTemplate(this.props.i18n.language)
      }));
    }
    /**
     *
     * @param fieldName
     * @param value
     */

  }, {
    key: "handleInputChange",
    value: function handleInputChange(fieldName, value) {
      var selectFields = {
        canton: 'canton',
        salutation: 'salutation',
        operatingmode: 'operatingmode',
        mainlanguage: 'languages',
        productiontype: 'productiontype',
        acquisitiontype: 'acquisitiontype'
      };

      if (Object.keys(selectFields).includes(fieldName)) {
        value = this.state[selectFields[fieldName]].find(function (selectItem) {
          return parseInt(selectItem.id) === parseInt(value);
        });
      }

      var updateData = {};
      updateData[fieldName] = value;
      this.props.updateFarmData(updateData);
    }
    /**
     *
     * @param fieldName
     * @param value
     */

  }, {
    key: "handleInputChangeMultiSelect",
    value: function handleInputChangeMultiSelect(fieldName, value) {
      var selectFields = {
        animals: 'animals',
        otherlanguages: 'languages',
        cultures: 'cultures',
        zones: 'zones',
        productionlabels: 'productionlabels',
        programs: 'programs'
      };
      value = value.map(function (id) {
        return parseInt(id);
      });
      value = this.state[selectFields[fieldName]].filter(function (selectItem) {
        return value.includes(parseInt(selectItem.id));
      });
      var updateData = {};
      updateData[fieldName] = value;
      this.props.updateFarmData(updateData);
    }
    /**
     *
     * @param event
     */

  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var _this3 = this;

      event.preventDefault();

      if (!this.props.farm.id) {
        return void 0;
      }

      var farm = _lodash.default.clone(this.props.farm);

      delete farm.id;
      this.setState(function (prev) {
        prev.isSaving = true;
        return prev;
      });
      fetch("".concat(_conf.default.api.farmApiUrlTemplate(this.props.i18n.language), "/").concat(this.props.farm.id), {
        method: 'PUT',
        body: JSON.stringify(farm),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function () {
        _this3.setState(function (prev) {
          prev.form = {
            error: null,
            success: true,
            invalidFields: {
              fields: [],
              details: {}
            }
          };
          prev.isSaving = false;
          return prev;
        });

        setTimeout(function () {
          _this3.setState(function (prev) {
            prev.form.success = false;
          });
        }, 5000);
      }).catch(function (error) {
        var message = error.message;
        var invalidFields = {};

        if (error.status === 422) {
          invalidFields = _lodash.default.get(error, 'details.codes');
        }

        _this3.setState(function (prev) {
          prev.form = {
            error: message,
            invalidFields: {
              fields: Object.keys(invalidFields),
              details: invalidFields
            },
            success: false
          };
          prev.isSaving = false;
          return prev;
        });
      });
    }
    /**
     *
     * @param newPosition
     */

  }, {
    key: "onMarkerMoved",
    value: function onMarkerMoved(newPosition) {
      this.props.updateFarmData({
        latitude: newPosition.latitude.toString(),
        longitude: newPosition.longitude.toString()
      });
    }
    /**
     *
     */

  }, {
    key: "loadFarmDataOnly",
    value: function loadFarmDataOnly() {
      var _this4 = this;

      fetch("".concat(_conf.default.api.farmApiUrlTemplate(this.props.i18n.language), "/").concat(this.props.farm.id), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (farm) {
        _this4.props.updateFarmData(farm);
      });
    }
    /**
     *
     * @param files
     * @param type
     */

  }, {
    key: "onUploadFile",
    value: function onUploadFile(files, type) {
      var updateData = {};
      updateData[type] = this.props.farm[type].concat(files);
      this.props.updateFarmData(updateData);
    }
    /**
     *
     * @param file
     * @param allImages
     */

  }, {
    key: "onUpdateSorting",
    value: function onUpdateSorting(images) {
      var _this5 = this;

      var uri = _conf.default.api.farmApiUpdateSorting(this.props.i18n.language, this.props.id);

      fetch(uri, {
        credentials: 'include',
        method: 'PUT',
        body: JSON.stringify(images),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(_fetchUtils.default.checkStatus).then(function (result) {
        var updatedImages = result.allImages;
        var mainImage = updatedImages.find(function (image) {
          return image.is_main === 1;
        });
        mainImage = mainImage || updatedImages[0];

        _this5.props.updateFarmData({
          images: updatedImages,
          mainImage: _this5.applyImage(_this5.props.farm, mainImage.id)
        });

        return Promise.resolve();
      }).catch(function (err) {
        void 0;
      });
    }
    /**
     *
     * @param file
     * @param type
     */

  }, {
    key: "onDeleteFile",
    value: function onDeleteFile(file, type) {
      var _this6 = this;

      return (0, _files.removeFile)(this.props.id, file.id, type, this.props.i18n.languages).then(function (result) {
        var updateData = {};
        updateData[type] = _this6.props.farm[type].filter(function (file) {
          return file.id !== result.fileId;
        });

        if (type === 'image') {
          updateData.mainImage = _this6.applyImage(_this6.props.farm, result.fileId);
        }

        _this6.props.updateFarmData(updateData);

        return Promise.resolve();
      });
    }
    /**
     *
     * @param image
     */

  }, {
    key: "onUpdateMainImage",
    value: function onUpdateMainImage(image) {
      var _this7 = this;

      var uri = _conf.default.api.farmApiMainImage(this.props.i18n.language, this.props.id, image.id);

      fetch(uri, {
        credentials: 'include',
        method: 'PUT'
      }).then(_fetchUtils.default.checkStatus).then(function (result) {
        _this7.props.updateFarmData({
          mainImage: _this7.applyImage(_this7.props.farm, result.fileId),
          logo: _this7.props.farm.logo.id === image.id ? 0 : _this7.props.farm.logo
        });
      });
    }
    /**
     *
     * @param image
     */

  }, {
    key: "onUpdateLogo",
    value: function onUpdateLogo(image) {
      var _this8 = this;

      var uri = _conf.default.api.farmApiLogo(this.props.i18n.language, this.props.id, image.id);

      fetch(uri, {
        credentials: 'include',
        method: 'PUT'
      }).then(_fetchUtils.default.checkStatus).then(function (result) {
        _this8.props.updateFarmData({
          logo: _this8.applyImage(_this8.props.farm, result.fileId),
          mainImage: _this8.props.farm.mainImage.id === image.id ? 0 : _this8.props.farm.mainImage
        });
      });
    }
    /**
     *
     * @param farm
     * @param imageId
     * @returns {*}
     */

  }, {
    key: "applyImage",
    value: function applyImage(farm, imageId) {
      return farm.images.find(function (image) {
        return parseInt(image.id) === parseInt(imageId);
      }) || farm.images[0];
    }
    /**
     *
     * @param suggestion
     */

  }, {
    key: "saveSuggestionData",
    value: function saveSuggestionData(suggest) {
      this.handleInputChange('zip', suggest.zip);
      this.handleInputChange('city', suggest.city);
      this.handleInputChange('canton', suggest.canton);
    }
    /**
     *
     */

  }, {
    key: "onGeocode",
    value: function onGeocode() {
      var country = 'Switzerland';

      if (this.props.farm.canton && this.props.farm.canton.short && this.props.farm.canton.short === 'LI') {
        country = 'Liechtenstein';
      }

      var geoData = [this.props.farm.street, this.props.farm.zip + ' ' + this.props.farm.city, country];
      var fullAddress = geoData.join(', ');
      var geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({
        address: fullAddress
      }, function (res, status) {
        if (status === 'OK') {
          this.onMarkerMoved({
            latitude: res[0].geometry.location.lat(),
            longitude: res[0].geometry.location.lng()
          });
        } else {
          void 0; // set default marker if something went wrong. so we have at least coordinates in switzerland

          this.onMarkerMoved({
            latitude: 46.909957,
            longitude: 8.498662
          });
        }
      }.bind(this));
    }
  }]);

  return Farm;
}(_baseForm.default);

Farm.defaultProps = {
  anchorId: 'farm-data'
};
Farm.propTypes = {
  anchorId: _propTypes.default.any,
  id: _propTypes.default.any.isRequired,
  farm: _propTypes.default.any.isRequired,
  t: _propTypes.default.any,
  i18n: _propTypes.default.object,
  updateFarmData: _propTypes.default.func.isRequired
};

var _default = (0, _translate.default)(Farm);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/farm/farm.js
// module id = 56
// module chunks = 0